import format from 'date-fns/format';
import ptBR from 'date-fns/locale/pt-BR';

/**
 *
 * @param input Date
 * @returns do de MMMM de yyyy, ex: 01 de janeiro de 2022
 * @example showMonthYear(new Date(2022, 1, 1))
 * @returns 01 de janeiro de 2022
 */
export const showDayMonthYearAsText = (input: Date): string =>
  format(input, "dd 'de' MMMM 'de' yyyy", { locale: ptBR });
